export const getters = {
  GET_MEMBERINFO (state) {
    return state.memberInfo
  }
}



// WEBPACK FOOTER //
// ./src/store/member/getters.js